import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Globe, X } from 'lucide-react';
import { locales, SUPPORTED } from '../i18n';

const LS_KEY = 'langBannerDismissed';

const LanguageBanner = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [target, setTarget] = useState(null);

  useEffect(() => {
    if (localStorage.getItem(LS_KEY)) return;
    if (location.pathname.startsWith('/admin')) return;

    // current site language from the first path segment
    const seg = location.pathname.split('/')[1];
    const current = SUPPORTED.includes(seg) ? seg : 'en';

    // detect the visitor's browser language
    const navLangs = (navigator.languages && navigator.languages.length)
      ? navigator.languages
      : [navigator.language || 'en'];
    const primary = (navLangs[0] || 'en').slice(0, 2).toLowerCase();

    // suggest a supported language that differs from the current one
    let suggest = null;
    if (primary === 'fr' && current !== 'fr') suggest = 'fr';
    else if (primary !== 'fr' && current !== 'en') suggest = 'en';

    if (suggest) {
      setTarget(suggest);
      setVisible(true);
    }
  }, [location.pathname]);

  const dismiss = () => {
    localStorage.setItem(LS_KEY, '1');
    setVisible(false);
  };

  const switchLang = () => {
    const parts = location.pathname.split('/');
    if (SUPPORTED.includes(parts[1])) {
      parts[1] = target;
    } else {
      parts.splice(1, 0, target);
    }
    localStorage.setItem(LS_KEY, '1');
    setVisible(false);
    const dest = parts.join('/') || `/${target}`;
    navigate(dest);
  };

  if (!visible || !target) return null;
  const t = locales[target].banner;

  return (
    <div className="relative z-[60] w-full bg-cream border-b-2" style={{ borderColor: 'var(--teal)' }}>
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-2.5 flex items-center gap-3">
        <span className="flex items-center justify-center w-8 h-8 rounded-full shrink-0" style={{ background: 'rgba(153,14,229,.12)' }}>
          <Globe className="w-4.5 h-4.5" style={{ color: 'var(--teal)', width: 18, height: 18 }} />
        </span>
        <p className="font-body text-sm md:text-[15px] flex-1 leading-snug" style={{ color: 'var(--navy)' }}>
          {t.message}
        </p>
        <button
          onClick={switchLang}
          className="btn-coral font-head font-semibold text-xs md:text-sm px-4 py-2 rounded-md shrink-0"
        >
          {t.yes}
        </button>
        <button
          onClick={dismiss}
          aria-label={t.dismiss}
          className="shrink-0 p-1.5 rounded-md text-navy/60 hover:text-navy hover:bg-black/5 transition-colors"
        >
          <X className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default LanguageBanner;
